import { StorePlayerColor } from '../entity_datas/StoreEnums.ts';
import { PlayerColor } from '@colonist/game-states';
export const GIFT_MEMBERSHIP_EXPIRY_YEARS = 2;
export class BaseStoreItem {
    static getStorePlayerColorOfPlayerColor(color) {
        switch(color){
            case PlayerColor.None:
                return undefined;
            case PlayerColor.Red:
                return undefined;
            case PlayerColor.Blue:
                return undefined;
            case PlayerColor.Orange:
                return undefined;
            case PlayerColor.Green:
                return undefined;
            case PlayerColor.Black:
                return StorePlayerColor.Black;
            case PlayerColor.Purple:
                return StorePlayerColor.Purple;
            case PlayerColor.MysticBlue:
                return StorePlayerColor.MysticBlue;
            case PlayerColor.White:
                return StorePlayerColor.White;
            case PlayerColor.Bronze:
                return StorePlayerColor.Bronze;
            case PlayerColor.Silver:
                return StorePlayerColor.Silver;
            case PlayerColor.Gold:
                return StorePlayerColor.Gold;
            case PlayerColor.Pink:
                return StorePlayerColor.Pink;
        }
    }
    static getPlayerColorOfStorePlayerColor(color) {
        switch(color){
            case StorePlayerColor.Gold:
                return PlayerColor.Gold;
            case StorePlayerColor.Silver:
                return PlayerColor.Silver;
            case StorePlayerColor.Bronze:
                return PlayerColor.Bronze;
            case StorePlayerColor.Black:
                return PlayerColor.Black;
            case StorePlayerColor.Purple:
                return PlayerColor.Purple;
            case StorePlayerColor.MysticBlue:
                return PlayerColor.MysticBlue;
            case StorePlayerColor.White:
                return PlayerColor.White;
            case StorePlayerColor.Pink:
                return PlayerColor.Pink;
        }
    }
    constructor(){
        this.activeInStore = false;
        this.hideOnDiscordMobile = false;
    }
}
